import getWeekNumber from "./getWeekNumber.js";
const createWeekNumbers = (self, firstDayWeek, daysSelectedMonth, weekNumbersEl, daysEl) => {
  if (!self.settings.visibility.weekNumbers)
    return;
  const dayEls = daysEl.querySelectorAll(`.${self.CSSClasses.day}`);
  weekNumbersEl.innerHTML = "";
  const countWeek = Math.ceil((firstDayWeek + daysSelectedMonth) / 7);
  const weekNumbersTitleEl = document.createElement("b");
  weekNumbersTitleEl.className = self.CSSClasses.weekNumbersTitle;
  weekNumbersTitleEl.innerText = "#";
  weekNumbersEl.append(weekNumbersTitleEl);
  const weekNumbersContentEl = document.createElement("div");
  weekNumbersContentEl.className = self.CSSClasses.weekNumbersContent;
  weekNumbersEl.append(weekNumbersContentEl);
  const templateWeekNumberEl = document.createElement("span");
  templateWeekNumberEl.className = self.CSSClasses.weekNumber;
  for (let i = 0; i < countWeek; i++) {
    let dayBtnEl = null;
    if (i === 0) {
      dayBtnEl = dayEls[6].querySelector(`.${self.CSSClasses.dayBtn}`);
    } else {
      dayBtnEl = dayEls[i * 7].querySelector(`.${self.CSSClasses.dayBtn}`);
    }
    const weekNumber = getWeekNumber(dayBtnEl.dataset.calendarDay, self.settings.iso8601);
    if (!weekNumber)
      return;
    const weekNumberEl = templateWeekNumberEl.cloneNode(true);
    weekNumberEl.innerText = `${weekNumber.week}`;
    weekNumberEl.dataset.calendarYearWeek = `${weekNumber.year}`;
    weekNumbersContentEl.append(weekNumberEl);
  }
};
export {
  createWeekNumbers as default
};
